
export const RECEIVE_PLUGINS = "RECEIVE_PLUGINS"
export const SEARCH_PLUGINS = "SEARCH_PLUGINS"
export const CLEAR_FILTER_AND_SEARCH = "CLEAR_FILTER_AND_SEARCH"
export const FILTER_PLUGINS = "FILTER_PLUGINS"
export const CHANGE_PLUGIN = "CHANGE_PLUGIN"
